const ES = {
  // header / nav / footer
  "We Buy in Bulk": "Al por mayor",
  "How It Works": "Cómo funciona",
  "Watch & Learn": "Mira y aprende",
  "Track a package": "Rastrear un paquete",
  "Paste your USPS or UPS tracking number to see where your package is.": "Pegue su número de rastreo de USPS o UPS para ver dónde está su paquete.",
  "e.g. 9400 1118 9922 3197 4284 90": "ej. 9400 1118 9922 3197 4284 90",
  "Looks like a {c} number:": "Parece un número de {c}:",
  "Choose your carrier:": "Elija su transportista:",
  "Tracking opens on the official carrier website.": "El rastreo se abre en el sitio oficial del transportista.",
  "reviews": "reseñas",
  "verified": "verificadas",
  "Leave a Review": "Deje una reseña",
  "Leave a review": "Deje una reseña",
  "Verified customer": "Cliente verificado",
  "Verified reviews from our customers will appear here soon.": "Las reseñas verificadas de nuestros clientes aparecerán aquí pronto.",
  "Email or phone number": "Correo o número de teléfono",
  "Continue": "Continuar",
  "Something went wrong": "Algo salió mal",
  "Already been paid by StripWise? We'd love to hear how it went. Enter your quote number and the email or phone number you used, so we know you're a real customer.": "¿Ya recibió su pago de StripWise? Nos encantaría saber cómo le fue. Ingrese su número de cotización y el correo o teléfono que usó, para confirmar que es un cliente real.",
  "Happy Holidays from StripWise!": "¡Felices fiestas de parte de StripWise!",
  "Thank you for being part of our community.": "Gracias por ser parte de nuestra comunidad.",
  "Short videos to help you ship with confidence": "Videos cortos para enviar con confianza",
  "Quick, friendly tips from our team — tap any video to watch.": "Consejos rápidos y amables de nuestro equipo: toca cualquier video para verlo.",
  "Price List": "Precios",
  "FAQs": "Preguntas",
  "Reviews": "Reseñas",
  "Contact Us": "Contacto",
  "About": "Nosotros",
  "Home": "Inicio",
  "Track My Payout": "Rastrear mi pago",
  "Sell Your Strips": "Venda sus tiras",
  "Sign In": "Iniciar sesión",
  "Call / Text": "Llamar / Texto",
  "Email": "Correo",
  "Menu": "Menú",
  "Quick Links": "Enlaces rápidos",
  "Contact": "Contacto",
  "Areas We Serve (50 States)": "Áreas que atendemos (50 estados)",
  "Agent Login": "Acceso de agentes",
  "Follow us on Facebook": "Síganos en Facebook",
  "Live Chat": "Chat en vivo",
  "Talk to a real person now": "Hable con una persona real ahora",
  "Chat, call, text or WhatsApp — we reply fast with a free quote.": "Chat, llamada, texto o WhatsApp: respondemos rápido con una cotización gratis.",
  "Reply in minutes": "Respuesta en minutos",
  "Email us": "Escríbanos",
  "Or email us at": "O escríbanos a",
  "or": "o",
  "Call Us": "Llámenos",
  "All rights reserved.": "Todos los derechos reservados.",
  "We only purchase sealed, unexpired supplies.": "Solo compramos suministros sellados y vigentes.",
  "{brand} helps people resell sealed, unexpired testing supplies they no longer need. Free quotes, free shipping and friendly people, nationwide.": "{brand} ayuda a las personas a revender suministros para pruebas sellados y sin vencer que ya no necesitan. Cotización gratis, envío gratis y gente amable en todo el país.",
  "Hi! I'd like to sell my strips.": "¡Hola! Quiero vender mis tiras.",
  // pills
  "Text me": "Envíeme texto",
  "WhatsApp me": "WhatsApp",
  "Email us:": "Escríbanos:",
  // chat
  "Online now": "En línea ahora",
  "Support": "Soporte",
  "Close chat": "Cerrar chat",
  "Call": "Llamar",
  "Text": "Texto",
  "Hi there! I'm {name}. Tell me what supplies you have and I'll send you a fair offer in minutes. Tip: tap the photo button to send pictures of your boxes and expiration dates for faster pricing.": "¡Hola! Soy {name}. Cuénteme qué suministros tiene y le envío una oferta justa en minutos. Consejo: toque el botón de foto para enviar imágenes de sus cajas y fechas de vencimiento y así cotizar más rápido.",
  "Your name": "Su nombre",
  "Phone or email": "Teléfono o correo",
  "Type your message...": "Escriba su mensaje...",
  "Close": "Cerrar",
  "Chat with {name}": "Chatee con {name}",
  "You can attach up to 5 photos per message": "Puede adjuntar hasta 5 fotos por mensaje",
  "{f} is not an image": "{f} no es una imagen",
  "{f} is larger than 8MB": "{f} pesa más de 8MB",
  "Message failed to send. Please try again.": "No se pudo enviar el mensaje. Inténtelo de nuevo.",
  "Attach photos of your boxes (up to 5)": "Adjunte fotos de sus cajas (hasta 5)",
  "Reply": "Responder",
  "Copy": "Copiar",
  "Delete": "Eliminar",
  "Copied": "Copiado",
  "You": "Usted",
  "Replying to": "Respondiendo a",
  "Forwarded": "Reenviado",
  "This message was deleted": "Se eliminó este mensaje",
  "Attach": "Adjuntar",
  "Photos & videos": "Fotos y videos",
  "Take photo": "Tomar foto",
  "Record video": "Grabar video",
  "Document": "Documento",
  "Seen": "Visto",
  "Message info": "Info del mensaje",
  "React": "Reaccionar",
  "Download": "Descargar",
  "Edit": "Editar",
  "Edited": "Editado",
  "Edit message": "Editar mensaje",
  "Download failed": "No se pudo descargar",
  "From": "De",
  "Not seen yet": "Aún no visto",
  "Sent": "Enviado",
  "Sending…": "Enviando…",
  "{name} is typing…": "{name} está escribiendo…",
  "Hold to record a voice note": "Mantenga presionado para grabar una nota de voz",
  "Release to send · slide left to cancel": "Suelte para enviar · deslice a la izquierda para cancelar",
  "Microphone access is blocked. Please allow it in your browser settings.": "El micrófono está bloqueado. Permítalo en la configuración de su navegador.",
  "You can attach up to 5 files per message": "Puede adjuntar hasta 5 archivos por mensaje",
  // hero
  "Tap for sound": "Toque para activar el sonido",
  "Get a Free Quote": "Cotización gratis",
  "Chat & Start Selling": "Chatee y empiece a vender",
  "Hi! I'd like to start selling my supplies.": "¡Hola! Quiero empezar a vender mis suministros.",
  "Rather talk now?": "¿Prefiere hablar ahora?",
  "Text Us": "Envíenos texto",
  "Same-day": "Mismo día",
  "Payouts": "Pagos",
  "Highest": "Los mejores",
  "Pricing": "Precios",
  "Free": "Gratis",
  "Pickup": "Recogida",
  "Chat With Us": "Chatee con nosotros",
  "Live now · fast replies": "En vivo · respuestas rápidas",
  "Email Us": "Escríbanos",
  "Three easy steps, from extra boxes to a finished sale": "Tres pasos sencillos, desde sus cajas extra hasta una venta terminada",
  "Get a Quote": "Pida una cotización",
  "Tell us which sealed, unexpired items you have using our short form or live chat. We'll reply with a clear, no-obligation offer.": "Díganos qué artículos sellados y sin vencer tiene con nuestro formulario corto o el chat. Le responderemos con una oferta clara y sin compromiso.",
  "Free Pickup": "Recogida gratis",
  "Like the offer? We send a prepaid shipping label with your quote. Pack your box, drop it off, and shipping costs you nothing.": "¿Le gusta la oferta? Le enviamos una etiqueta de envío prepagada con su cotización. Empaque su caja, llévela al correo y el envío no le cuesta nada.",
  "Get Paid Your Way": "Reciba su pago a su manera",
  "Once your package arrives and is checked, we pay you with the method you picked: Zelle, PayPal, Venmo, Cash App, Chime or ACH.": "Cuando su paquete llega y lo revisamos, le pagamos con el método que eligió: Zelle, PayPal, Venmo, Cash App, Chime o ACH.",
  // why choose / brands / supplies
  "Do your boxes fit the bill?": "¿Sus cajas califican?",
  "Why Choose {brand}?": "¿Por qué elegir {brand}?",
  "Friendly service, clear offers and free shipping, from your first message to your final payment.": "Servicio amable, ofertas claras y envío gratis, desde su primer mensaje hasta su pago final.",
  "Fast Payouts": "Pagos rápidos",
  "We let you know when your box arrives and when your payment is sent.": "Le avisamos cuando llega su caja y cuando enviamos su pago.",
  "A prepaid label comes with every accepted quote.": "Cada cotización aceptada incluye una etiqueta prepagada.",
  "Quick Response": "Respuesta rápida",
  "Call, text or chat, and a real team member will help you.": "Llame, envíe un texto o escriba por chat y una persona real de nuestro equipo le ayudará.",
  "Trusted & Secure": "Confiable y seguro",
  "Your details stay private, and every step is explained.": "Sus datos son privados y le explicamos cada paso.",
  "Help the Community": "Ayude a la comunidad",
  "Sealed supplies get a second life instead of going in the trash.": "Los suministros sellados tienen una segunda vida en lugar de ir a la basura.",
  "Best Pricing": "Mejores precios",
  "Clear offers based on quantity, condition and dates.": "Ofertas claras según la cantidad, el estado y las fechas.",
  "Sell Now": "Vender ahora",
  "Manufacturer Brands": "Marcas de fabricantes",
  "We accept sealed, unexpired supplies from many well-known brands. Tap a brand to ask for a quote.": "Aceptamos suministros sellados y sin vencer de muchas marcas conocidas. Toque una marca para pedir una cotización.",
  "Chat with us": "Chatee con nosotros",
  "Text us": "Envíenos texto",
  "Hi! I'd like a quote for my {name} supplies.": "¡Hola! Quiero una cotización para mis suministros {name}.",
  "Hi StripWise! I'd like a quote for my {name} supplies.": "¡Hola StripWise! Quiero una cotización para mis suministros {name}.",
  "Hi! I'd like a quote for {name} ({size}).": "¡Hola! Quiero una cotización para {name} ({size}).",
  "Hi StripWise! I'd like a quote for {name} ({size}).": "¡Hola StripWise! Quiero una cotización para {name} ({size}).",
  "All product photos © {brand}. Don't see your brand? Chat with us for a custom quote.": "Todas las fotos de productos © {brand}. ¿No ve su marca? Escríbanos para una cotización personalizada.",
  "In stock": "Compramos",
  "Paused": "En pausa",
  "Up to": "Hasta",
  "What We Buy": "Lo que compramos",
  "Supplies We Purchase": "Suministros que compramos",
  "Browse the items we accept, filter by brand, and tap any item to ask for a quote.": "Vea los artículos que aceptamos, filtre por marca y toque cualquiera para pedir una cotización.",
  "Featured item this week —": "Artículo destacado de la semana:",
  "Chat About This Deal": "Pregunte por esta oferta",
  "Hi! I'm interested in the {title} deal ({amount}).": "¡Hola! Me interesa la oferta de {title} ({amount}).",
  "All": "Todas",
  "Sort by": "Ordenar por",
  "Offer: high to low": "Oferta: de mayor a menor",
  "Offer: low to high": "Oferta: de menor a mayor",
  "Name A–Z": "Nombre A–Z",
  "All product photos © {brand}. Swipe to see more · Don't see your item? Chat with us for a custom quote.": "Todas las fotos de productos © {brand}. Deslice para ver más · ¿No ve su artículo? Escríbanos para una cotización personalizada.",
  // info sections
  "Testimonials": "Testimonios",
  "Customer Reviews": "Reseñas de clientes",
  "About Us": "Sobre nosotros",
  "Frequently Asked Questions": "Preguntas frecuentes",
  "Answers to the questions people ask us most. Please only send sealed, unexpired items in good condition. We can't accept or return items that are expired, opened or damaged.": "Respuestas a las preguntas más frecuentes. Por favor, envíe solo artículos sellados, sin vencer y en buen estado. No podemos aceptar ni devolver artículos vencidos, abiertos o dañados.",
  "Still have questions?": "¿Todavía tiene preguntas?",
  "Our team is here to help with anything about selling your diabetic supplies.": "Nuestro equipo está aquí para ayudarle con todo lo relacionado con la venta de sus suministros.",
  "Get in Touch": "Contáctenos",
  "Contact {brand}": "Contacte a {brand}",
  "Reach us on any channel that works for you.": "Comuníquese por el medio que prefiera.",
  "Call / SMS": "Llamada / SMS",
  "Address": "Dirección",
  "Request a Free Quote": "Pida una cotización gratis",
  "Tell us what you have and we'll send a fair offer.": "Cuéntenos qué tiene y le enviaremos una oferta justa.",
  "Thanks! Your quote number is": "¡Gracias! Su número de cotización es",
  "Save it to": "Guárdelo para",
  "track your payout": "rastrear su pago",
  "Full name *": "Nombre completo *",
  "Phone": "Teléfono",
  "Supplies (e.g. 3 Dexcom G7, exp. 2027)": "Suministros (ej. 3 Dexcom G7, vence 2027)",
  "Anything else we should know?": "¿Algo más que debamos saber?",
  "Send Request": "Enviar solicitud",
  "Prefer to chat?": "¿Prefiere chatear?",
  "Send us a message": "Envíenos un mensaje",
  "Please add your name and an email or phone number.": "Agregue su nombre y un correo o teléfono.",
  "Request sent! We'll reach out with your offer shortly.": "¡Solicitud enviada! Le contactaremos pronto con su oferta.",
  "Something went wrong. Please try again or chat with us.": "Algo salió mal. Inténtelo de nuevo o escríbanos por chat.",
  // nationwide
  "Serving All 50 States": "Atendemos los 50 estados",
  "Sell Your Extra Test Strips From Anywhere in the USA": "Venda sus tiras reactivas extra desde cualquier lugar de EE. UU.",
  "nationwide_body": "Viva donde viva, {brand} le facilita vender los suministros sellados y sin vencer que ya no necesita. Aceptamos artículos como sensores Dexcom, FreeStyle Libre, pods Omnipod, y tiras OneTouch, Contour y Accu-Chek. Pida una cotización gratis, envíe con la etiqueta prepagada que le mandamos y elija cómo quiere recibir su pago.",
  "Free prepaid label": "Etiqueta prepagada gratis",
  "Clear, fair offers": "Ofertas claras y justas",
  "All 50 states": "Los 50 estados",
  "Get My Free Quote": "Quiero mi cotización gratis",
  "Hi! I'd like to sell my test strips. Which state do you ship from?": "¡Hola! Quiero vender mis tiras reactivas. ¿Desde qué estado envían?",
  "Popular cities we buy from": "Ciudades populares donde compramos",
  "States we serve": "Estados que atendemos",
  // bulk / prices
  "Selling a Larger Quantity?": "¿Vende una cantidad mayor?",
  "Have a large number of sealed, unexpired supplies? {brand} offers free bulk quotes, prepaid shipping and one-on-one help.": "¿Tiene una gran cantidad de suministros sellados y sin vencer? {brand} ofrece cotizaciones gratis por volumen, envío prepagado y ayuda personalizada.",
  "Get a Bulk Quote": "Cotización al por mayor",
  "Hi! I have a bulk order to sell.": "¡Hola! Tengo un pedido grande para vender.",
  "Any Quantity": "Cualquier cantidad",
  "From a few boxes to full cases, we're happy to take a look.": "Desde unas pocas cajas hasta cajas completas, con gusto las revisamos.",
  "Volume Bonuses": "Bonos por volumen",
  "Larger sealed lots may qualify for a better offer per box.": "Los lotes sellados más grandes pueden recibir una mejor oferta por caja.",
  "Free Freight": "Flete gratis",
  "Prepaid labels for every accepted order, big or small.": "Etiquetas prepagadas para cada pedido aceptado, grande o pequeño.",
  "Fast Inspection": "Inspección rápida",
  "We check every item and keep you updated until payment is sent.": "Revisamos cada artículo y le mantenemos informado hasta enviar su pago.",
  "Current Offer Guide": "Guía de ofertas actual",
  "Offers depend on quantity, condition and expiration date. Chat with {brand} for an exact quote.": "Las ofertas dependen de la cantidad, el estado y la fecha de vencimiento. Escriba a {brand} para una cotización exacta.",
  "Search products or brands": "Buscar productos o marcas",
  "table": "tabla",
  "grid": "cuadrícula",
  "Product": "Producto",
  "Brand": "Marca",
  "Size": "Tamaño",
  "Expiry": "Vencimiento",
  "Payout": "Pago",
  "Sell": "Vender",
  "No products match your search.": "Ningún producto coincide con su búsqueda.",
  // track
  "Payout Tracker": "Rastreo de pago",
  "Where's my payment?": "¿Dónde está mi pago?",
  "Enter your quote number (like": "Ingrese su número de cotización (como",
  ") and the email or phone you used.": ") y el correo o teléfono que usó.",
  "Quote number": "Número de cotización",
  "Email or phone": "Correo o teléfono",
  "Track": "Rastrear",
  "Not found": "No encontrado",
  "Quote": "Cotización",
  "Hi {name}, status:": "Hola {name}, estado:",
  "via": "por",
  "Request received": "Solicitud recibida",
  "Offer sent": "Oferta enviada",
  "Package on the way": "Paquete en camino",
  "Package received": "Paquete recibido",
  "Payment sent": "Pago enviado",
  "Pending": "Pendiente",
  "Questions? Chat with us": "¿Preguntas? Chatee con nosotros",
  "Hi! Question about my quote {code}.": "¡Hola! Tengo una pregunta sobre mi cotización {code}.",
  // review
  "Go to homepage": "Ir al inicio",
  "Thank you{name}!": "¡Gracias{name}!",
  "Your review helps other sellers find a buyer they can trust.": "Su reseña ayuda a otros vendedores a encontrar un comprador confiable.",
  "Back to StripWise": "Volver a StripWise",
  "How did we do{name}?": "¿Cómo lo hicimos{name}?",
  "Rate your experience selling with StripWise.": "Califique su experiencia vendiendo con StripWise.",
  "What was it like selling to us?": "¿Cómo fue vendernos?",
  "Name to show (e.g. Maria G.)": "Nombre a mostrar (ej. María G.)",
  "City, State (e.g. Houston, TX)": "Ciudad, estado (ej. Houston, TX)",
  "Submit review": "Enviar reseña",
  "Free quote": "Cotización gratis",
  "No obligation": "Sin compromiso",
  "Free shipping": "Envío gratis",
  "Prepaid label": "Etiqueta prepagada",
  "Real people": "Personas reales",
  "Here to help": "Listas para ayudar",
  "Ship for Free": "Envíe gratis",
  "Clear Updates": "Avisos claros",
  "Free Shipping": "Envío gratis",
  "Honest & Private": "Honestos y privados",
  "Less Waste": "Menos desperdicio",
  "Fair Offers": "Ofertas justas",
  "Volume Pricing": "Precio por volumen",
  "Careful Inspection": "Revisión cuidadosa",
};

const STATUS_ES = { "New": "Nueva", "Request received": "Solicitud recibida", "Offer sent": "Oferta enviada", "Package on the way": "Paquete en camino", "Shipped": "Enviado", "Package received": "Paquete recibido", "Received": "Recibido", "Payment sent": "Pago enviado", "Paid": "Pagado" };

export const translate = (lang, s, vars) => {
  let out = lang === "es" ? ES[s] ?? STATUS_ES[s] ?? s : s;
  if (vars) Object.entries(vars).forEach(([k, v]) => { out = out.split(`{${k}}`).join(v ?? ""); });
  return out;
};

const empty = (v) => v === undefined || v === null || v === "";

// Deep-merges Spanish overrides onto English content; arrays merge by index.
export const mergeLang = (a, b) => {
  if (empty(b)) return a;
  if (Array.isArray(a)) return a.map((x, i) => mergeLang(x, Array.isArray(b) ? b[i] : undefined));
  if (a && typeof a === "object") {
    const out = { ...a };
    Object.keys(b || {}).forEach((k) => { out[k] = mergeLang(a[k], b[k]); });
    return out;
  }
  return b;
};

export const localizeContent = (c, lang) => {
  if (!c || lang !== "es") return c;
  const m = mergeLang(c, c.es || {});
  return { ...m, testimonials: (c.testimonials || []).map((t) => ({ ...t, text: t.text_es || t.text })) };
};
